module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0041.jpg?v=7b3ab7aa";